import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';
import { HrFlexContainer, HrFont, HrFontBold } from '@components/styles/hr-styles';
import { DisplaySettingsContext } from '../../store/display-settings';

const BounceAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1 }
  100% { opacity: 0 }
`;
const DotWrapper = styled.div`
  font-family: ${HrFont};
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px`};
  font-weight: ${HrFontBold};
  display: flex;
  gap: 4px;
  align-items: baseline;
  color: ${(props) => props.color || ''} ;
`;
const Dot = styled.div`
  background-color: ${(props) => props.background || 'black'};
  border-radius: 50%;
  width: 4px;
  height: 4px;
  animation: ${BounceAnimation} 1s linear infinite;
  animation-delay: ${(props) => props.delay};
`;


export const ScreenLoadImportCV = ({ minHeight, imgWidth, flexDirection }) => {
  const [t] = useTranslation();
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);
  const imgPath = '/assets/img/app/postulants/'
  return (
    <HrFlexContainer background={darkMode ? '#1A1D2B' : ''} justifyContent='center' gap='32px' minHeight={minHeight} flexDirection={flexDirection}>
      <img 
        src={`${imgPath}${darkMode ? 'search-file-negative.svg' : 'search-file.svg'}`}
        alt='dos personas buscando archivos'
        width={imgWidth || '200'}
      />
      <DotWrapper fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
        {t('Estamos importando tu CV')}
        <Dot background={darkMode ? 'white' : ''} delay='0s' />
        <Dot background={darkMode ? 'white' : ''} delay='.1s' />
        <Dot background={darkMode ? 'white' : ''} delay='.2s' />
      </DotWrapper>
    </HrFlexContainer>
  );
};
